import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=2e9508a1&scoped=true&lang=pug&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=2e9508a1&prod&lang=sass&"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=2e9508a1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9508a1",
  null
  
)

export default component.exports